var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubelCommas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E7E7E7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260 4026c0-3.53.074-7.7.223-12.507.224-6.836 1.304-11.793 3.241-14.873s5.364-4.62 10.281-4.62l1.341 5.746c-2.682.076-4.507.977-5.476 2.705-.894 1.652-1.34 4.131-1.34 7.436h7.822V4026H260zm22.908 0c0-3.53.075-7.7.224-12.507.223-6.836 1.303-11.793 3.24-14.873 1.938-3.08 5.364-4.62 10.281-4.62l1.341 5.746c-2.682.076-4.507.977-5.475 2.705-.894 1.652-1.341 4.131-1.341 7.436H299V4026h-16.092z",
    transform: "translate(-260 -3994)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubelCommas);
export default __webpack_public_path__ + "static/media/doubel-commas.f6eafb2d59abfb7ffd4305fe142a28dc.svg";
export { ForwardRef as ReactComponent };